<div class="no-access-wrapper">
    <div class="no-access-card">
        <div class="no-access-icon">🔒</div>
        <h1 class="no-access-title">Access Denied</h1>
        <p class="no-access-subtitle">You don't have permission to access this application.</p>
        <p class="no-access-detail">
            Please contact your administrator or submit a request for access to <strong>{{ title }}</strong>.
        </p>
        <a *ngIf="supportLink" [href]="supportLink" target="_blank" class="no-access-btn">
            Request Access
        </a>
    </div>
</div>
